import React, { useState } from 'react';
import Select from 'react-select';
import { sortByOptions } from '../contants/data';

const SortBy = ({ onSortBy }) => {
  const [selectedSortBy, setSelectedSortBy] = useState(sortByOptions[0]);

  const handleSortByChange = (option) => {
    setSelectedSortBy(option);
    onSortBy(option);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minWidth: 'fit-content', // container width based on content
    }),
    menu: (provided) => ({
      ...provided,
      width: 'max-content', // fit width to longest option
      minWidth: '100%', // make sure at least same as control
    }),
    option: (provided) => ({
      ...provided,
      whiteSpace: 'nowrap',
      textAlign: 'left',
    }),
    singleValue: (provided) => ({
      ...provided,
      whiteSpace: 'nowrap',
      textAlign: 'left',
    }),
  };

  return (
    <div>
      <Select
        options={sortByOptions}
        onChange={handleSortByChange}
        value={selectedSortBy}
        className='border-0'
        styles={customStyles}
      />
    </div>
  );
};

export default SortBy;
